import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-checked\">\r\n  <rect x=\"1.5\" y=\"1.5\" width=\"13\" height=\"13\" rx=\"0.5\" stroke=\"#D1D1D1\" />\r\n  <path d=\"M12.1818 5L6.72727 10.4545L4 7.72742\" stroke=\"#72747A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol